const DASHBOARD_URLS = {
    GET_COUNTS:"business/dash_board/get_count",
    GET_TOP_SALES_REDEEMED: "/business/orders_items/business_dashboard",
    GET_CHART_COUNTS:"/business/dash_board/get_count_year"
}

export {
    DASHBOARD_URLS
}